import Statsig from 'statsig-js';

export interface OnboardingConfig {
  taskId: string | null;
  taskName: string | null;
}

export function getOnboardingConfig(defaultTaskId: string | null = 'caa1214c-9f0f-477a-b30e-ad672ddf5087'): OnboardingConfig {
  try {
    const config = Statsig.getConfig('conversationalOnboardingConfig');
    
    if (!config) {
      return { taskId: null, taskName: null };
    }

    const taskId = config.get('taskId', defaultTaskId);
    const taskName = config.get('taskName', 'Getting to Know You');
    
    return {
      taskId: taskId || null,
      taskName: taskName || null,
    };
  } catch (error) {
    // If Statsig is not initialized or throws an error, return default
    return { taskId: defaultTaskId, taskName: 'Getting to Know You' };
  }
}